import React, { useState } from 'react';
import './CalculatorPage.css';

function BirthDateStrengthAnalyzer() {
  const [dob, setDob] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const analyzeStrength = (dateString) => {
    // Placeholder for Birth Date Strength analysis logic
    // This is a simplified example; real analysis would be more complex.
    const digitsOnly = dateString.replace(/\D/g, '');

    if (digitsOnly.length !== 8) {
      return null; // Invalid length
    }

    const day = parseInt(digitsOnly.substring(0, 2), 10);
    const month = parseInt(digitsOnly.substring(2, 4), 10);
    const year = parseInt(digitsOnly.substring(4, 8), 10);

    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > 2100) {
      return null; // Invalid date components
    }

    let strengthScore = 0;
    // Example: Assign points based on certain numbers or patterns
    if (day === 1 || day === 10 || day === 19 || day === 28) strengthScore += 10; // Strong leadership
    if (month === 7 || month === 11) strengthScore += 5; // Spiritual inclination
    if (year % 2 === 0) strengthScore += 3; // Stability

    return strengthScore;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(dob)) {
      setError('Please enter a valid date in DD/MM/YYYY format.');
      return;
    }

    const calculated = analyzeStrength(dob);
    if (calculated === null) {
      setError('Invalid date. Please check your input.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (score) => {
    return `Your Birth Date Strength Score is ${score}. This is a placeholder explanation for birth date strength.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Birth Date Strength Analyzer",
    "description": "Analyze the numerological strength and characteristics of your birth date.",
    "url": "https://www.yourwebsite.com/birth-date-strength-analyzer",
    "potentialAction": {
      "@type": "AnalyzeAction",
      "name": "Analyze Birth Date Strength",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/birth-date-strength-analyzer?dob={dob}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=dob"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Birth Date Strength Analyzer</h1>
      <p className="text-center">Enter your Date of Birth to analyze its numerological strength.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="dob">Date of Birth (DD/MM/YYYY):</label>
          <input
            type="text"
            id="dob"
            className="form-control"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            placeholder="e.g., 01/01/1990"
            maxLength="10"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Analyze Strength</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Birth Date Strength Score: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default BirthDateStrengthAnalyzer;
